<template>
  <v-dialog v-model="uploadDialog" width="786">
    <slot name="header" />
    <v-card class="upload-dialog">
      <upload-file :isDialog="true" @reload="getImagesResource" ref="uploadComponent" />
      <div class="alert-box" v-if="uploadedFiles.length == 0">
        <p>{{ $t("NO_PHOTOS_FOUND") }}</p>
      </div>
      <image-gallary
        :isDialog="true"
        :isChooseOneOnly="isChooseOneOnly"
        :totalFiles="total"
        :uploadedFiles.sync="uploadedFiles"
        :selectedFiles.sync="selectedFiles"
        ref="imageGallary"
      />
      <paging v-if="paging.total" :paging.sync="paging" @changePage="getImagesResource">
        <v-checkbox
          id="select-all-ckb"
          color="indigo darken-3"
          v-if="!isChooseOneOnly"
          slot="selectAll"
          v-model="isSelectAll"
          :label="selecteAllLabel"
          @change="selectAll($event)"
        ></v-checkbox>
        <span
          slot="totalItems"
          v-if="paging"
        >{{ $t("TOTAL") }}: {{ paging.total }} {{ $t("IMAGES") }}</span>
      </paging>
      <v-card-actions class="pa-0">
        <v-spacer></v-spacer>
        <v-btn depressed outlined class="pr-5 pl-5" @click="close">{{ $t("CLOSE") }}</v-btn>
        <v-btn
          color="primary"
          class="pr-5 pl-5"
          :class="{ disabled: !selectedFiles.length }"
          :disabled="!selectedFiles.length"
          @click="uploadTargetImage"
        >{{ $t("CHOOSE") }} ({{ selectedFiles.length }})</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
const LIMIT_AND_OFFSET_DIALOG = {
  limit: 15,
  offset: 0
};
import UploadController from "@/components/HotelSetting/GalleryManager/UploadController";
import ImageGallary from "@/components/HotelSetting/GalleryManager/ImageGallery";
import Paging from "@/components/Utils/Paging.vue";
import { systemService } from "@/_services/system-data.service.js";

export default {
  components: {
    "upload-file": UploadController,
    "image-gallary": ImageGallary,
    paging: Paging
  },
  props: {
    isChooseOneOnly: Boolean,
    sourceFile: Array,
    logo: String,
  },
  data() {
    return {
      uploadDialog: false,
      isSelectAll: false,
      total: 0,
      uploadedFiles: [],
      selectedFiles: [],
      paging: {
        total: 0,
        limit: 0,
        offset: 0
      },
      pagingNoted: null
    };
  },
  created() {
    this.initialize();
  },
  watch: {
    uploadDialog(val) {
      //if (this.$refs.uploadComponent) this.$refs.uploadComponent.resetStatus();
      if (val) {
        this.initialize();
      }
    }
  },
  computed: {
    justUploaded() {
      return this.$store.state.hotelImage.justUploaded;
    },
    selecteAllLabel() {
      return `${this.$t("SELECT_ALL")} (${this.total} ${this.$t("IMAGES")})`;
    }
  },
  methods: {
    initialize() {
      if (this.sourceFile) {
        this.selectedFiles = this.sourceFile;
      }
      let params = LIMIT_AND_OFFSET_DIALOG;
      if(this.pagingNoted){
        params = {
          limit: this.pagingNoted.limit,
          offset: this.pagingNoted.offset,
        }
      }
      this.getImagesResource(params);
    },
    async getImagesResource(params, justUploaded) {
      if (!params) {
        params = LIMIT_AND_OFFSET_DIALOG;
      }
      await systemService.getImagesResource(params).then(res => {
        this.total = res.total;
        if (this.logo && params.offset === 0) {
          let logo = {
            id: -1,
            img: this.logo
          };
          this.uploadedFiles = [];
          this.uploadedFiles.push(logo);
          this.uploadedFiles.push(...res.data.slice(0, res.data.length - 1));
          if (!this.selectedFiles.length) {
            this.selectedFiles.push(logo);
          }
        } else {
          this.uploadedFiles = res.data;
        }
        this.paging = {
          total: res.total,
          limit: params.limit,
          offset: params.offset
        };
        if (
          this.$route.name == "registerInfomation" &&
          !this.selectedFiles.length &&
          this.logo
        ) {
          let logo = res.data.find(x => x.img == this.logo);
          if (logo) this.selectedFiles.push(logo);
        }
      });
      if (justUploaded)
        this.$store.commit("hotelImage/storedListJustUploaded", justUploaded);
    },
    open() {
      this.uploadDialog = true;
    },
    close() {
      this.uploadDialog = false;
    },
    deleteImage() {
      this.$emit("deleteImage");
      this.close();
    },
    async selectAll(e) {
      let params = {
        limit: this.total,
        offset: 0
      };
      let res = await systemService.getImagesResource(params);
      this.$refs.imageGallary.selectAll(e, res.data);
    },
    uploadTargetImage() {
      this.pagingNoted = this.paging;
      this.isSelectAll = false;
      let data = this.$refs.imageGallary.getListSelected();
      //this.$refs.imageGallary.removeAllSelected();
      this.$emit("uploadTargetImage", data);
      this.close();
    }
  }
};
</script>
